<template>
  <div>
    <div
      class="fixed md:top-0 md:bottom-auto bottom-0 left-0 md:w-[500px] md:p-8 md:pt-10 md:pb-24 p-4 w-full bg-white z-50 shadow-lg transition-transform transform rounded-r-2xl flex flex-col gap-6 md:max-h-screen max-h-[80vh] overflow-y-auto"
      :class="{
        'md:-translate-x-full md:translate-y-0 translate-y-full': !sliderOpen,
        'md:translate-x-0 translate-y-0': sliderOpen,
      }"
      @click.stop
    >
      <!-- Content for the sliding panel goes here -->
      <div class="w-full flex items-center justify-between">
        <div class="flex items-center gap-2">
          <GreyQorayLogo />
          <h2 class="font-inter font-semibold text-2xl">{{ station.name }}</h2>
        </div>
        <span @click="closeSlider">
          <GreyCloseIcon />
        </span>
      </div>
      <div class="w-full">
        <img :src="station.img_url" class="rounded-md" alt="" />
      </div>
      <div class="w-full flex flex-col gap-4">
        <div class="row">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_4383_22277)">
              <path
                d="M22 11.25H19.96C19.6 7.44 16.56 4.39 12.75 4.04V2C12.75 1.59 12.41 1.25 12 1.25C11.59 1.25 11.25 1.59 11.25 2V4.04C7.44 4.4 4.39 7.44 4.04 11.25H2C1.59 11.25 1.25 11.59 1.25 12C1.25 12.41 1.59 12.75 2 12.75H4.04C4.4 16.56 7.44 19.61 11.25 19.96V22C11.25 22.41 11.59 22.75 12 22.75C12.41 22.75 12.75 22.41 12.75 22V19.96C16.56 19.6 19.61 16.56 19.96 12.75H22C22.41 12.75 22.75 12.41 22.75 12C22.75 11.59 22.41 11.25 22 11.25ZM12 15.12C10.28 15.12 8.88 13.72 8.88 12C8.88 10.28 10.28 8.88 12 8.88C13.72 8.88 15.12 10.28 15.12 12C15.12 13.72 13.72 15.12 12 15.12Z"
                fill="#292D32"
              />
            </g>
            <defs>
              <clipPath id="clip0_4383_22277">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <p class="md:text-base text-sm">{{ station.address }}</p>
        </div>
        <div class="">
          <div
            class="row border-b pb-2 border-b-[#4f4f51] border-opacity-15 pt-2"
            v-for="charger in station.chargers"
            :key="charger.charger_type"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.4202 8.99656C20.2802 8.98656 20.1002 8.97656 19.9002 8.97656C19.5102 8.97656 19.2002 9.28656 19.2002 9.67656V14.3266C19.2002 14.7166 19.5102 15.0266 19.9002 15.0266C20.1002 15.0266 20.2702 15.0166 20.4402 15.0066C22.0002 14.8266 22.0002 13.7266 22.0002 12.9266V11.0666C22.0002 10.2666 22.0002 9.16656 20.4202 8.99656Z"
                fill="#292D32"
              />
              <path
                d="M12.93 4.78906H7.35C3.25 4.78906 2 6.03906 2 10.1391V13.8591C2 17.9591 3.25 19.2091 7.35 19.2091H12.93C17.03 19.2091 18.28 17.9591 18.28 13.8591V10.1391C18.28 6.03906 17.03 4.78906 12.93 4.78906ZM12.53 13.6791C12.51 13.7191 12.48 13.7591 12.45 13.7891L10.58 15.9791C10.43 16.1491 10.22 16.2391 10.01 16.2391C9.84 16.2391 9.66 16.1791 9.52 16.0591C9.21 15.7891 9.17 15.3191 9.44 14.9991L11.24 12.8891C11.25 12.8591 11.24 12.8291 11.22 12.7991C11.2 12.7591 11.16 12.7391 11.11 12.7391H9.12C8.53 12.7391 8.01 12.4391 7.71 11.9291C7.42 11.4191 7.42 10.8191 7.71 10.3091L9.42 8.04906C9.67 7.71906 10.14 7.64906 10.47 7.89906C10.8 8.14906 10.87 8.61906 10.62 8.94906L8.97 11.1391C9 11.0991 9 11.1391 9.02 11.1891C9.04 11.2291 9.08 11.2491 9.13 11.2491H11.14C11.73 11.2491 12.25 11.5491 12.55 12.0591C12.82 12.5691 12.82 13.1691 12.53 13.6791Z"
                fill="#292D32"
              />
            </svg>
            <div>
              <!-- <div class="flex flex-col w-full items-start gap-4"> -->
              <span class="flex flex-col w-full items-start gap-2">
                <div class="w-full">
                  <span class="md:text-base text-sm text-[#5E5E5E]">
                    {{ charger.count }}
                    {{
                      charger.charger_type.toLowerCase() === "dc"
                        ? "Fast"
                        : charger.charger_type
                    }}
                    {{ `Charger${charger.count > 1 ? "s" : ""}` }}</span
                  >
                </div>

                <!-- <span
                    v-if="index + 1 !== station.chargers.length"
                    class="inline-block w-[2px] h-[2px] rounded-full bg-newGrey"
                  ></span> -->
                <!-- <span
                  v-for="(charger, index) in station.chargers"
                  :key="charger.charger_type + index"
                  class="inline-flex items-center gap-2"
                > -->
                <div class="w-full">
                  <span class="md:text-base text-sm text-[#5E5E5E]">
                    {{ charger.charger_type }}:
                  </span>

                  <span class="md:text-base text-sm text-[#5E5E5E]">
                    {{ charger.power_rating }}kW
                  </span>

                  <span
                    class="inline-block w-[2px] h-[2px] rounded-full bg-newGrey"
                  ></span>

                  <span class="md:text-base text-sm font-bold text-green">
                    ₦{{ charger.price_per_kwh }}/kWh
                  </span>

                  <!-- <span
                      v-if="index + 1 !== station.chargers.length"
                      class="inline-block w-[1px] h-3 rounded-full bg-newGrey"
                    ></span> -->
                </div>
                <div class="row w-full">
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.92822 11.5469V19.0195"
                      stroke="black"
                      stroke-width="1.425"
                      stroke-linecap="round"
                    />
                    <path
                      d="M13.6908 6.99852V9.63593C13.6908 10.6878 12.8381 11.5407 11.7861 11.5407H6.07176C5.01978 11.5407 4.16699 10.6878 4.16699 9.63593V6.99852C4.16699 5.94654 5.01978 5.09375 6.07176 5.09375H11.7861C12.8381 5.09375 13.6908 5.94654 13.6908 6.99852Z"
                      fill="black"
                      stroke="black"
                      stroke-width="1.425"
                      stroke-linecap="round"
                    />
                    <path
                      d="M12.1035 5.09064V1.86719"
                      stroke="black"
                      stroke-width="1.425"
                      stroke-linecap="round"
                    />
                    <path
                      d="M5.75391 5.09064V1.86719"
                      stroke="black"
                      stroke-width="1.425"
                      stroke-linecap="round"
                    />
                    <path
                      d="M15.2778 13L13.6904 15.8571H17.5L15.9126 18.7143"
                      stroke="black"
                      stroke-width="1.425"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <div class="">
                    <div class="flex items-center gap-2">
                      <span
                        v-for="(connector, idx) in charger.connector_types"
                        :key="connector + idx"
                        class="md:text-base text-sm text-[#5E5E5E] flex items-center gap-2"
                      >
                        <span>
                          {{ connector }}
                        </span>
                        <span
                          v-if="idx + 1 !== charger.connector_types.length"
                          class="inline-block w-[2px] h-[2px] rounded-full bg-newGrey"
                        ></span>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- </span> -->
              </span>
              <!-- </div> -->

              <!-- <div class="flex items-center gap-2"></div> -->
            </div>
          </div>
        </div>
        <div class="row">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.7502 3.56V2C16.7502 1.59 16.4102 1.25 16.0002 1.25C15.5902 1.25 15.2502 1.59 15.2502 2V3.5H8.75023V2C8.75023 1.59 8.41023 1.25 8.00023 1.25C7.59023 1.25 7.25023 1.59 7.25023 2V3.56C4.55023 3.81 3.24023 5.42 3.04023 7.81C3.02023 8.1 3.26023 8.34 3.54023 8.34H20.4602C20.7502 8.34 20.9902 8.09 20.9602 7.81C20.7602 5.42 19.4502 3.81 16.7502 3.56Z"
              fill="#292D32"
            />
            <path
              d="M19 15C16.79 15 15 16.79 15 19C15 19.75 15.21 20.46 15.58 21.06C16.27 22.22 17.54 23 19 23C20.46 23 21.73 22.22 22.42 21.06C22.79 20.46 23 19.75 23 19C23 16.79 21.21 15 19 15ZM21.07 18.57L18.94 20.54C18.8 20.67 18.61 20.74 18.43 20.74C18.24 20.74 18.05 20.67 17.9 20.52L16.91 19.53C16.62 19.24 16.62 18.76 16.91 18.47C17.2 18.18 17.68 18.18 17.97 18.47L18.45 18.95L20.05 17.47C20.35 17.19 20.83 17.21 21.11 17.51C21.39 17.81 21.37 18.28 21.07 18.57Z"
              fill="#292D32"
            />
            <path
              d="M20 9.83594H4C3.45 9.83594 3 10.2859 3 10.8359V16.9959C3 19.9959 4.5 21.9959 8 21.9959H12.93C13.62 21.9959 14.1 21.3259 13.88 20.6759C13.68 20.0959 13.51 19.4559 13.51 18.9959C13.51 15.9659 15.98 13.4959 19.01 13.4959C19.3 13.4959 19.59 13.5159 19.87 13.5659C20.47 13.6559 21.01 13.1859 21.01 12.5859V10.8459C21 10.2859 20.55 9.83594 20 9.83594ZM9.21 18.2059C9.02 18.3859 8.76 18.4959 8.5 18.4959C8.24 18.4959 7.98 18.3859 7.79 18.2059C7.61 18.0159 7.5 17.7559 7.5 17.4959C7.5 17.2359 7.61 16.9759 7.79 16.7859C7.89 16.6959 7.99 16.6259 8.12 16.5759C8.49 16.4159 8.93 16.5059 9.21 16.7859C9.39 16.9759 9.5 17.2359 9.5 17.4959C9.5 17.7559 9.39 18.0159 9.21 18.2059ZM9.21 14.7059C9.16 14.7459 9.11 14.7859 9.06 14.8259C9 14.8659 8.94 14.8959 8.88 14.9159C8.82 14.9459 8.76 14.9659 8.7 14.9759C8.63 14.9859 8.56 14.9959 8.5 14.9959C8.24 14.9959 7.98 14.8859 7.79 14.7059C7.61 14.5159 7.5 14.2559 7.5 13.9959C7.5 13.7359 7.61 13.4759 7.79 13.2859C8.02 13.0559 8.37 12.9459 8.7 13.0159C8.76 13.0259 8.82 13.0459 8.88 13.0759C8.94 13.0959 9 13.1259 9.06 13.1659C9.11 13.2059 9.16 13.2459 9.21 13.2859C9.39 13.4759 9.5 13.7359 9.5 13.9959C9.5 14.2559 9.39 14.5159 9.21 14.7059ZM12.71 14.7059C12.52 14.8859 12.26 14.9959 12 14.9959C11.74 14.9959 11.48 14.8859 11.29 14.7059C11.11 14.5159 11 14.2559 11 13.9959C11 13.7359 11.11 13.4759 11.29 13.2859C11.67 12.9159 12.34 12.9159 12.71 13.2859C12.89 13.4759 13 13.7359 13 13.9959C13 14.2559 12.89 14.5159 12.71 14.7059Z"
              fill="#292D32"
            />
          </svg>
          <p
            class="md:text-base text-sm"
            v-html="station.open_hours?.replace(/,/g, '<br />')"
          />
        </div>
        <div class="row !items-center">
          <p class="md:text-base text-sm">
            <span v-if="isOpen.isOpen" class="text-[#198639]">{{
              "Open"
            }}</span>
            <span v-else class="text-red">{{ "Closed" }}</span>
          </p>
          <span class="w-[2px] h-[2px] bg-[#5E5E5E] inline-block"></span>
          <p class="md:text-base text-sm">
            {{ isOpen.text }}
          </p>
        </div>
      </div>
      <div class="w-full">
        <button
          class="black-btn w-full md:text-base text-sm"
          @click="openSchedule"
        >
          Schedule Charge
        </button>
      </div>
    </div>
    <div
      v-if="sliderOpen"
      class="fixed inset-0 z-40"
      @click="closeSlider"
    ></div>
  </div>
</template>

<script>
import GreyCloseIcon from "../GreyCloseIcon.vue";
import GreyQorayLogo from "../GreyQorayLogo.vue";
export default {
  components: { GreyQorayLogo, GreyCloseIcon },
  props: ["sliderOpen", "station", "closeSlider"],
  data() {
    return {
      // Add any additional data properties here
    };
  },
  methods: {
    // Add any methods you need here
    openSchedule() {
      this.closeSlider();
      this.$store.dispatch("openSchedule", this.station.slug);
    },
  },
  computed: {
    isOpen() {
      return this.$store.getters.isOpen(this.station.open_hours);
    },
  },
  watch: {
    sliderOpen(newVal) {
      if (newVal) {
        // console.log(this.station);
        return (document.body.style.overflow = "hidden");
      } else {
        return (document.body.style.overflow = "auto");
      }
    },
  },
  mounted() {
    // Ensure the body overflow is set correctly when the component is mounted
  },
};
</script>

<style lang="scss" scoped >
.row {
  @apply flex items-start gap-2;
  p {
    @apply text-[#5E5E5E] text-lg font-inter;
  }
}
</style>